export const isDeviceIPhone = (platform: string): boolean =>
  ['iPhone Simulator', 'iPhone'].includes(platform)
